module.exports = __webpack_public_path__ + "static/media/lunalovegood.c98fb441.jpeg";